import { GetUserType } from '@orbit/api-types'
import { useMemo } from 'react'

export const useSortedMembers = (
	members: GetUserType[],
	me: GetUserType | undefined,
	settledById: Map<number, boolean>,
): GetUserType[] => {
	return useMemo(() => {
		return [...members].sort((a, b) => {
			if (me) {
				if (a.id === me.id) return -1
				if (b.id === me.id) return 1
			}
			const aSettled = settledById.get(a.id) ?? true
			const bSettled = settledById.get(b.id) ?? true
			if (aSettled !== bSettled) return aSettled ? 1 : -1
			return 0
		})
	}, [members, me, settledById])
}
